import { ROLE } from '@app/constants/permission'
import { ICON_NAME } from '@app/constants/icon'
import {
  REGISTRY_PAGE,
  INTERNAL_TASKS_PAGE,
  QUOTE_REPORT_PAGE,
  MONITORING_LAUNCH_PAGE,
  CONTRACTOR_SECTION_PAGE,
  PROCESSING_RESULTS_PAGE,
  MONITORING_REGISTRY_PAGE,
  EXTERNAL_PRODUCTS_CATALOG_PAGE,
  TRANSFER_RESULTS_PAGE
} from '@app/constants/page'

import type { RawMenuItemGroup } from '@app/types/menu/raw'

export const rawMenuItems: RawMenuItemGroup[] = [
  {
    label: 'Списки товаров',
    children: [
      {
        key: REGISTRY_PAGE.registry,
        label: 'Реестр списков',
        iconProps: { name: ICON_NAME.catalog },
        requiredRoles: [
          ROLE.priceAnalyticsSpecialist,
          ROLE.pricingSpecialist,
          ROLE.commercialServiceSpecialist,
          ROLE.promoPlanningSpecialist,
          ROLE.commercialServiceDirector
        ]
      }
    ]
  },
  {
    label: 'Мониторинги цен',
    children: [
      {
        key: MONITORING_LAUNCH_PAGE.monitoringLaunch,
        label: 'Запуск мониторингов',
        iconProps: { name: ICON_NAME.startMonitoring },
        requiredRoles: [ROLE.priceAnalyticsSpecialist]
      },
      {
        key: MONITORING_REGISTRY_PAGE.monitoringRegistry,
        label: 'Реестр мониторингов',
        iconProps: { name: ICON_NAME.catalogMonitoring },
        requiredRoles: [ROLE.priceAnalyticsSpecialist, ROLE.pricingSpecialist]
      },
      {
        key: CONTRACTOR_SECTION_PAGE.contractorSection,
        label: 'Раздел подрядчика',
        iconProps: { name: ICON_NAME.contractorSection },
        requiredRoles: [ROLE.contractor]
      },
      {
        key: PROCESSING_RESULTS_PAGE.processingResults,
        label: 'Обработка результатов',
        iconProps: { name: ICON_NAME.resultMonitoring },
        requiredRoles: [
          ROLE.priceAnalyticsSpecialist,
          ROLE.pricingSpecialist,
          ROLE.categoryManager,
          ROLE.promoPlanningSpecialist,
          ROLE.commercialServiceDirector,
          ROLE.commercialServiceSpecialist
        ]
      },
      {
        key: TRANSFER_RESULTS_PAGE.transferResults,
        label: 'Передача результатов',
        iconProps: { name: ICON_NAME.transferResults },
        requiredRoles: [ROLE.priceAnalyticsSpecialist, ROLE.pricingSpecialist]
      }
    ]
  },
  {
    label: 'Квоты',
    children: [
      {
        key: QUOTE_REPORT_PAGE.quoteReport,
        label: 'Отчет по квотам',
        iconProps: { name: ICON_NAME.report },
        requiredRoles: [
          ROLE.priceAnalyticsSpecialist,
          ROLE.pricingSpecialist,
          ROLE.commercialServiceSpecialist,
          ROLE.promoPlanningSpecialist,
          ROLE.commercialServiceDirector
        ]
      }
    ]
  },
  {
    label: 'Рабочий список',
    children: [
      {
        key: INTERNAL_TASKS_PAGE.internalTasks,
        label: 'Список задач',
        iconProps: { name: ICON_NAME.report },
        requiredRoles: [
          ROLE.priceAnalyticsSpecialist,
          ROLE.pricingSpecialist,
          ROLE.commercialServiceSpecialist,
          ROLE.commercialServiceDirector,
          ROLE.promoPlanningSpecialist
        ]
      }
    ]
  },
  {
    label: 'Внешние товары',
    children: [
      {
        key: EXTERNAL_PRODUCTS_CATALOG_PAGE.externalProductsCatalog,
        label: 'Справочник товаров',
        iconProps: { name: ICON_NAME.catalog },
        requiredRoles: [
          ROLE.priceAnalyticsSpecialist,
          ROLE.pricingSpecialist,
          ROLE.categoryManager,
          ROLE.commercialServiceDirector,
          ROLE.commercialServiceSpecialist
        ]
      }
    ]
  }
]
